import React from 'react'

import { ConnectedPageTopbarProps } from 'features/common/page-topbar'
import styled from 'styled-components'
import { Icon, PageTopbar, STYLED_VARIABLES } from '@cloudike/web_ui_components'

type AlbumPageTopbarProps = ConnectedPageTopbarProps & {
  onBack: () => void
}

export const AlbumsSeasonsPageTopbar: React.FC<AlbumPageTopbarProps> = ({
  className = '',
  title,
  onBack,
  selectedItemsCount,
  selectedText,
  onCancelSelection
}) => {

  if (selectedItemsCount) {
    return (
      <StyledPageTopbar
        title={title}
        selectedText={selectedText}
        selectedItemsCount={selectedItemsCount}
        onCancelSelection={onCancelSelection}
      />
    )
  }

  return (
    <AlbumPageTopbarBox className={className}>
      <BackButton
        onClick={onBack}
        iconName="ArrowLeftCircle"
      />

      <AlbumInfo>
        <AlbumName>
          {title}
        </AlbumName>
      </AlbumInfo>

    </AlbumPageTopbarBox>
  )
}

const AlbumPageTopbarBox = styled.div`
  width: 100%;
  min-height: 96px;
  display: flex;
  padding-top: 24px;

  @media screen and (max-width: ${STYLED_VARIABLES.BREAKPOINTS.PHONE_100}) {
    padding-left: 16px;
  }
`

const AlbumInfo = styled.div`
  overflow: hidden;
  display: flex;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-flow: column;
  flex-flow: column;
  margin-right: 0;
  padding-left: 16px;
  cursor: pointer;
`

const AlbumName = styled.h3`
  font-weight: 500;
  margin: 0;
  padding: 0;
  font-size: 24px;
  line-height: 40px;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.placeholder {
    /* Ink / Ink Lighter */
    color: var(--text-disable);
  }
`

const BackButton = styled(Icon)`
  width: 40px;
  height: 40px;
  cursor: pointer;
`

const StyledPageTopbar = styled(PageTopbar)`
  width: 100%;
  height: 96px;
  display: flex;
  align-items: unset;
  padding-top: 20px;
`
